import React, { useMemo, useState } from 'react';
import { EstabelecimentoContext } from './estabelecimento-context';

export const EstabelecimentoProvider = ({ children }) => {
  const [estabelecimento, setEstabelecimento] = useState(null);

  const memoizedValue = useMemo(
    () => ({
      estabelecimento,
      setEstabelecimento
    }),
    [estabelecimento]
  );

  return <EstabelecimentoContext.Provider value={memoizedValue}>{children}</EstabelecimentoContext.Provider>;
};
